import React ,{useState}from 'react'
import { useNavigate , useParams} from 'react-router-dom';
import { Button, Form,Container, Spinner } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import moment from 'moment'
import axios from 'axios';
import Notification from './../../Components/assets/Modals/notification'
import NotifyError from './../../Components/assets/Modals/errorModal'
import {REGISTER_SCHOOL_STUDENT} from './../../url/index'

const  eng_class_List= [
  {Id:0,Name:'Select'},
  {Id:1,Name:'Pre Nursery'},
  {Id:2,Name:'Nursery'},
  {Id:3,Name:'LKG'},
  {Id:4,Name:'UKG'},

  {Id:5,Name:'Standard 1'},
  {Id:6,Name:'Standard 2'},
  {Id:7,Name:'Standard 3'},
  {Id:8,Name:'Standard 4'},
  {Id:9,Name:'Standard 5'},
 
]

const odia_class_List = [
 
  {Id:0,Name:'Select'},
  {Id:10,Name:'Pre Nursery'},
  {Id:11,Name:'Nursery'},
  {Id:12,Name:'LKG'},
  {Id:13,Name:'UKG'},

  {Id:14,Name:'Class 1'},
  {Id:15,Name:'Class 2'},
  {Id:16,Name:'Class 3'},
  {Id:17,Name:'Class 4'},
  {Id:18,Name:'Class 5'}
 
]

const state_list = [
  {Id:'',Name:'Select'},
  {Id:'Odisha', Name:'Odisha'},
  {Id:'Bihar', Name:'Bihar'},
  {Id:'Jharkhand', Name:'Jharkhand'}
]




const School = () => {
  const navigate = useNavigate();
    const {id} = useParams ();
    const schoool_name = id == 1 ? "CTG Global School (Eng. Medium)" : "CTG Vidya Mandir (Odia Medium)" 
    const [isLoading, setLoading] = useState(false)
    const [IsSuccess, setSuccess] = useState(false)

    const[error_modal_info, setErrorModalInfo] = useState({ isHideErrorModal: true, msg: '', title: '',validationError:null})
    const[success_modal_info, setSuccessModalInfo] = useState({  msgList: [], title: 'Success'})

    const [currentStep, setCurrentStep] = useState(1);
    const [same_number, setSameNumber] = useState({is_f_cell_same_as_wapp:false, is_m_cell_same_as_wapp:false});
  
    const [formDataStep1, setFormDataStep1] = useState({ firstName: '', lastName: '', middleName:'', class:'' ,gender:'', blood_group:'', dateOfBirth:'', category:'', 
                                                         nationality:'Indian', religion:'', mother_tongue:'', aadhar_number:'', udise_code:''});
    const [formDataStep2, setFormDataStep2] = useState({ fatherName:'', f_qualification:'', f_Occupation: '', f_Organization:'',f_Annual_Income:'', f_Cell_Number:'',f_Wapp_Number:'',f_Email:'',f_Aadhar_Number:'',
                                                         motherName:'', m_qualification:'', m_Occupation:'', m_Organization:'', m_Annual_Income:'', m_Cell_Number:'', m_Wapp_Number:'',m_Email:'',m_Aadhar_Number:'',
                                                         c_House_No: '', c_street:'', c_City: '', c_Post:'', c_Block:'', c_District:'', c_zipCode: '', c_State:'',
                                                         p_House_No: '', p_street:'', p_City: '', p_Post:'', p_Block:'', p_District:'', p_zipCode: '', p_State:'', isPresntandCurrentAddressSame:false });
    const [formDataStep3, setFormDataStep3] = useState({ special_Abilities:'', health_Problem:'', allergy:'', lastSchool_Info:'', previous_Achievemnets:'', prev_Class:'',prev_Medium:'',prev_Mark:'',
                                                        is_OnlyChild:null, cousin1_Class:'', cousin1_Name:'', cousin1_School_Name:'',
                                                        cousin2_Class:'', cousin2_Name:'', cousin2_School_Name:'',
                                                        local_guardian_address:'',local_guardian_name:'',local_guardian_contact_number1:'',local_guardian_contact_number2:'',
                                                        accomodation_type:'', is_avail_transport:null, pickup_point:'',distance_from_school:''});
                                                         
    const [validationStep1, setValidationStep1] = useState(false);
    const [validationStep2, setValidationStep2] = useState(false);
    const [validationStep3, setValidationStep3] = useState(false);

    const handleNextStep = () => {
      if (currentStep === 1) {
        setValidationStep1(true);
        if (validateStep1()) {
          setCurrentStep(currentStep + 1);
        }
      } else if (currentStep === 2) {
        setValidationStep2(true);
        if (validateStep2()) {
          setCurrentStep(currentStep + 1);
        }
      }
      else if (currentStep === 3) {
        setValidationStep3(true);
        if (validateStep3()) {
          setCurrentStep(currentStep + 1);
        }
      }
      window.scrollTo(0, 0);
    };
  
    const handlePrevStep = () => {
      setCurrentStep(currentStep - 1);
      window.scrollTo(0, 0);
    };
  
    const validateStep1 = () => {
      return( formDataStep1.class.trim() !== '' && formDataStep1.firstName.trim() !== '' && formDataStep1.lastName.trim() !== '' 
      &&  formDataStep1.gender.trim() !== '' && 
      (formDataStep1.dateOfBirth.trim() !== '' && !formDataStep1.dateOfBirth.trim().includes('_'))  && 
       formDataStep1.category.trim() != ''
      &&  formDataStep1.nationality.trim() !== '' && formDataStep1.religion.trim() !== '' && 
      formDataStep1.mother_tongue.trim() !== '' && 
      (formDataStep1.aadhar_number.trim() !== '' && !formDataStep1.aadhar_number.trim().includes('_')) &&
      (formDataStep1.udise_code === '' || !formDataStep1.udise_code.includes('_')) 
      );
    };
  
    const validateStep2 = () => {
      return (
       
        formDataStep2.fatherName.trim() !== '' &&
        formDataStep2.f_qualification.trim() !== '' &&
        formDataStep2.f_Occupation.trim() !== '' &&
        formDataStep2.f_Organization.trim() !== '' &&
        formDataStep2.f_Annual_Income.trim() !== '' &&
        (formDataStep2.f_Cell_Number.trim() !== '' && !formDataStep2.f_Cell_Number.trim().includes('_'))&&
        (formDataStep2.f_Wapp_Number.trim() !== '' && !formDataStep2.f_Wapp_Number.trim().includes('_'))&&
        formDataStep2.f_Email.trim() !== '' &&
        (formDataStep2.f_Aadhar_Number.trim() !== '' && !formDataStep2.f_Aadhar_Number.trim().includes('_')) &&
        formDataStep2.c_House_No.trim() !== '' &&
        formDataStep2.c_street.trim() !== '' &&
        formDataStep2.c_City.trim() !== '' &&
        formDataStep2.c_Post.trim() !== '' &&
        formDataStep2.c_Block.trim() !== '' &&
        formDataStep2.c_District.trim() !== '' &&
        (formDataStep2.c_zipCode.trim() !== '' && !formDataStep2.c_zipCode.trim().includes('_'))&&
        formDataStep2.c_State.trim() !== '' &&


        formDataStep2.motherName.trim() !== '' &&
        formDataStep2.m_qualification.trim() !== '' &&
        formDataStep2.m_Occupation.trim() !== '' &&
        formDataStep2.m_Organization.trim() !== '' &&
        formDataStep2.m_Annual_Income.trim() !== '' &&
        (formDataStep2.m_Cell_Number.trim() !== '' && !formDataStep2.m_Cell_Number.trim().includes('_'))&&
        (formDataStep2.m_Wapp_Number.trim() !== '' && !formDataStep2.m_Wapp_Number.trim().includes('_'))&&
        formDataStep2.m_Email.trim() !== '' &&
        (formDataStep2.m_Aadhar_Number.trim() !== '' && !formDataStep2.m_Aadhar_Number.trim().includes('_')) &&
        
        formDataStep2.p_House_No.trim() !== '' &&
        formDataStep2.p_street.trim() !== '' &&
        formDataStep2.p_City.trim() !== '' &&
        formDataStep2.p_Post.trim() !== '' &&
        formDataStep2.p_Block.trim() !== '' &&
        formDataStep2.p_District.trim() !== '' &&
        (formDataStep2.p_zipCode.trim() !== '' && !formDataStep2.p_zipCode.trim().includes('_'))&&
        formDataStep2.p_State.trim() !== '' 
      );
    };

    const validateStep3 = () => {
      
      return (
        (formDataStep3.local_guardian_contact_number1 === '' || !formDataStep3.local_guardian_contact_number1.includes('_')) &&
        (formDataStep3.local_guardian_contact_number2 === '' || !formDataStep3.local_guardian_contact_number2.includes('_')) &&
        formDataStep3.is_OnlyChild !== null &&
        (formDataStep3.is_OnlyChild == true || 
        (formDataStep3.is_OnlyChild == false && formDataStep3.cousin1_Name.trim() !== '' &&
        formDataStep3.cousin1_Class.trim() !== '' &&
        formDataStep3.cousin1_School_Name.trim() !== ''))  &&
        formDataStep3.accomodation_type.trim() !== '' &&
        (formDataStep3.accomodation_type.trim() === 'Day Scholar' ||  formDataStep3.accomodation_type.trim() === 'Day Boarding' ? (formDataStep3.is_avail_transport !== null ? true:false) : true) &&
       (formDataStep3.is_avail_transport == true ? ((formDataStep3.pickup_point.trim() !== '' && formDataStep3.distance_from_school.trim() !== '' ) ? true: false): true)
        
      );
    };

const handleAddressCheckboxChange = (event) =>{

if (event.target.checked) {
  // If checkbox is checked, copy present address to permanent address
  setFormDataStep2({ ...formDataStep2, 
    p_House_No: formDataStep2.c_House_No, 
    p_street:formDataStep2.c_street, 
    p_City: formDataStep2.c_City,
    p_Post:formDataStep2.c_Post, 
    p_Block: formDataStep2.c_Block, 
    p_District: formDataStep2.c_District, 
    p_zipCode: formDataStep2.c_zipCode,
    p_State: formDataStep2.c_State,
    isPresntandCurrentAddressSame:true
  });
} else {
  // If checkbox is unchecked, clear permanent address
  setFormDataStep2({ ...formDataStep2, p_House_No: '', p_street:'', p_City: '', p_Post:'', p_Block:'', p_District:'', p_zipCode: '', p_State:'' ,  isPresntandCurrentAddressSame:false});
}

}

const handlefSameNumberChange =(event) => {
  setSameNumber({...same_number, is_f_cell_same_as_wapp: event.target.checked})
  if (event.target.checked) {
    setFormDataStep2({ ...formDataStep2, 
      f_Wapp_Number: formDataStep2.f_Cell_Number, 
    });
  }
  else{
    setFormDataStep2({ ...formDataStep2, 
      f_Wapp_Number: '', 
    });
  }
}

const handlemSameNumberChange =(event) => {
  setSameNumber({...same_number, is_m_cell_same_as_wapp: event.target.checked})
  if (event.target.checked) {
    setFormDataStep2({ ...formDataStep2, 
      m_Wapp_Number: formDataStep2.m_Cell_Number, 
    });
  }
  else{
    setFormDataStep2({ ...formDataStep2, 
      m_Wapp_Number: '', 
    });
  }
}



const handleSave = async() => {
  
  const payLoad = {
    "SchoolTypeId": parseInt(id),
    "ClassId": parseInt(formDataStep1.class) ,
    "FirstName": formDataStep1.firstName,
    "MiddleName": formDataStep1.middleName,
    "LastName": formDataStep1.lastName,
    "Gender": formDataStep1.gender,
    "Dob": moment.utc(formDataStep1.dateOfBirth, "DD-MM-YYYY"),
    "BloodGroup": formDataStep1.blood_group,
    "Nationality": formDataStep1.nationality,
    "Category": formDataStep1.category,
    "Religion": formDataStep1.religion,
    "MotherTongue": formDataStep1.mother_tongue,
    "AdhharNumber": formDataStep1.aadhar_number.replace(/\s+/g, ''),
    "PEN_Number": formDataStep1.udise_code.replace(/\s+/g, ''),
    "FatherName": formDataStep2.fatherName,
    "MotherName": formDataStep2.motherName,
    "FatherQualification": formDataStep2.f_qualification,
    "MotherQualification": formDataStep2.m_qualification,
    "FatherOccupation": formDataStep2.f_Occupation,
    "MotherOccupation": formDataStep2.m_Occupation,
    "FatherOrganization": formDataStep2.f_Organization,
    "MotherOrganization": formDataStep2.m_Organization,
    "FatherIncome": parseFloat(formDataStep2.f_Annual_Income),
    "MotherIncome": parseFloat(formDataStep2.m_Annual_Income),
    "FatherCellNumber": formDataStep2.f_Cell_Number,
    "MotherCellNumber": formDataStep2.m_Cell_Number,
    "FatherWappNumber": formDataStep2.f_Wapp_Number,
    "MotherWappNumber": formDataStep2.m_Wapp_Number,
    "FatherEmail": formDataStep2.f_Email,
    "MotherEmail": formDataStep2.m_Email,
    "FatherAdhharNumber": formDataStep2.f_Aadhar_Number.replace(/\s+/g, ''),
    "MotherAdhharNumber": formDataStep2.m_Aadhar_Number.replace(/\s+/g, ''),

    "PresentHouseNo": formDataStep2.c_House_No,
    "PermanentHouseNo": formDataStep2.p_House_No,
    "PresentStreet": formDataStep2.c_street,
    "PermanentStreet": formDataStep2.p_street,
    "PresentCityVillage": formDataStep2.c_City,
    "PermanentCityVillage": formDataStep2.p_City,
    "PresentPost": formDataStep2.c_Post,
    "PermanentPost": formDataStep2.p_Post,
    "PresentBlock": formDataStep2.c_Block,
    "PermanentBlock": formDataStep2.p_Block,
    "PresentDistrict": formDataStep2.c_District,
    "PermanentDistrict": formDataStep2.p_District,
    "PresentState": formDataStep2.c_State,
    "PermanentState": formDataStep2.p_State,
    "PresentPinCode": parseInt(formDataStep2.c_zipCode),
    "PermanentPinCode": parseInt(formDataStep2.p_zipCode),
    "IsPresentPermanentSame": formDataStep2.isPresntandCurrentAddressSame,

    "SpecialAbilities": formDataStep3.special_Abilities,
    "HealthProblem": formDataStep3.health_Problem,
    "Allergy": formDataStep3.allergy,
    "LastSchoolInfo": formDataStep3.lastSchool_Info,
    "LastSchoolMediumId": parseInt(formDataStep3.prev_Medium),
    "LastSchoolClassId": parseInt(formDataStep3.prev_Class),
    "LastSchoolMark": parseFloat(formDataStep3.prev_Mark),
    "PreviousAchievement": formDataStep3.previous_Achievemnets,
    "IsOnlyChild": formDataStep3.is_OnlyChild,
    "Sibling1Name": formDataStep3.cousin1_Name,
    "Sibling2Name": formDataStep3.cousin2_Name,
    "Sibling1ClassId": parseInt(formDataStep3.cousin1_Class),
    "Sibling2ClassId": parseInt(formDataStep3.cousin2_Class),
    "Sibling1School": formDataStep3.cousin1_School_Name,
    "Sibling2School": formDataStep3.cousin2_School_Name,
    "LocalGuardianName": formDataStep3.local_guardian_name,
    "LocalGuardianAddress": formDataStep3.local_guardian_address,
    "LocalGuardianCellNumber1": formDataStep3.local_guardian_contact_number1,
    "LocalGuardianCellNumber2": formDataStep3.local_guardian_contact_number2,
    "AccomodationType": formDataStep3.accomodation_type,
    "IsAvailTransport": formDataStep3.is_avail_transport,
    "PickupPoint": formDataStep3.pickup_point,
    "Distance": parseFloat(formDataStep3.distance_from_school)
}

try {
  setLoading(true)
 let response = await axios.post(REGISTER_SCHOOL_STUDENT, payLoad);

 if(response.status === 201)
 {
   //let msg = "You have successfully registered for " + schoool_name + ". Your registration number is " + response.data.Payload + ". Thank you for showing interest for CTG."
   let temp = []
   temp.push("You have successfully registered for " + schoool_name)
   temp.push("Your registration number is " + response.data.Payload)
   temp.push("The final admission will take place after submitting the necessary documents and fee at Office")
   setSuccessModalInfo({...success_modal_info, msgList: temp})

   setLoading(false)
   setSuccess(true)
   clearFormDataStep1()
   clearFormDataStep2()
   clearFormDataStep3()
   
}

else{
 setSuccessModalInfo({...success_modal_info, msgList: []})
  setLoading(false)
  setSuccess(true)
}
} catch (error) {
  setLoading(false)
  setSuccessModalInfo({...success_modal_info, msgList: []})
  if(error.response.data)
    {
       if(error.response.status === 400)
     {
      
        if(error.response.data.Error.ValidationErrors != null)
        {
          const validationError =  error.response.data.Error.ValidationErrors
         
          setErrorModalInfo({title:"Validation Error occurred!",
           msg: error.response.data.Error.Message, 
          validationError: validationError,
          isHideErrorModal: false
        })

        }
        else{

          setErrorModalInfo({title:"Error occurred!",
          msg: error.response.data.Error.Message, 
         isHideErrorModal: false
       })

        }
     
     }
     else{

      setErrorModalInfo({title:"Error occurred!",
      msg: "Please contact support." , 
     isHideErrorModal: false
   })
     }
    }
    else
    setErrorModalInfo({title:"Error occurred!",
      msg: "Please contact support." , 
     isHideErrorModal: false
   })
}

}

const handleClose = () => {
  setSuccess(false)
  setSuccessModalInfo({...success_modal_info, msgList: []})
  window.location.reload();
  window.scrollTo(0, 0);
}

const handleCloseErrorModal = () => {
  setSuccessModalInfo({...success_modal_info, msgList: []})
  setErrorModalInfo({title:"",
  msg: '', 
 validationError: null,
 isHideErrorModal: true
})
}

const clearFormDataStep1 = () => {
  setFormDataStep1({
    firstName: '', 
    lastName: '', 
    middleName: '', 
    class: '', 
    gender: '', 
    blood_group: '', 
    dateOfBirth: '', 
    category: '', 
    nationality: 'Indian', 
    religion: '', 
    mother_tongue: '', 
    aadhar_number: '', 
    udise_code: ''
  });
};

const clearFormDataStep2 = () => {
  setFormDataStep2({ fatherName:'', f_qualification:'', f_Occupation: '', f_Organization:'',f_Annual_Income:'', f_Cell_Number:'',f_Wapp_Number:'',f_Email:'',f_Aadhar_Number:'',
  motherName:'', m_qualification:'', m_Occupation:'', m_Organization:'', m_Annual_Income:'', m_Cell_Number:'', m_Wapp_Number:'',m_Email:'',m_Aadhar_Number:'',
  c_House_No: '', c_street:'', c_City: '', c_Post:'', c_Block:'', c_District:'', c_zipCode: '', c_State:'',
  p_House_No: '', p_street:'', p_City: '', p_Post:'', p_Block:'', p_District:'', p_zipCode: '', p_State:'', isPresntandCurrentAddressSame:false });
};

const clearFormDataStep3 = () => {
  setFormDataStep3({
    special_Abilities:'', health_Problem:'', allergy:'', lastSchool_Info:'', previous_Achievemnets:'', prev_Class:'',prev_Medium:'',prev_Mark:'',
    is_OnlyChild:null, cousin1_Class:'', cousin1_Name:'', cousin1_School_Name:'',
    cousin2_Class:'', cousin2_Name:'', cousin2_School_Name:'',
    local_guardian_address:'',local_guardian_name:'',local_guardian_contact_number1:'',local_guardian_contact_number2:'',
    accomodation_type:'', is_avail_transport:null, pickup_point:'',distance_from_school:''
  });
};

  return (
    <div className='school'>
       <div className='container'>
       <div className='schoolheading'>
               <label className = 'school-label'>Registration cum Admission Form</label>
               <br/>
              
               
               <div>
  {id == 1 ? (
    <label className = 'school-label'>
      <span >{"for CTG Global School"}</span>
      <span className="medium-text">{" (Eng. Medium)"}</span>
    </label>
  ) : (
    <label className = 'school-label'>
      <span>{"for CTG Vidya Mandir"}</span>
      <span className="medium-text">{" (Odia. Medium)"}</span>
    </label>
  )}
</div>


                </div>
       

                <div className="container mt-2">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8">
             <div className="progress">
              <div
                className={`progress-bar progress-bar-striped ${
                  currentStep === 1 ? 'bg-info' : (currentStep === 2 ||  currentStep === 3 )? 'bg-warning' : 'bg-success'
                }`}
                role="progressbar"
                style={{ width: `${(currentStep - 1) * 50}%` }}
              ></div>
            </div> 
           
              <div className="card-body">
                {/* Step 1 */}
                {currentStep === 1 && (
                  <div>
                    <h5 className="card-title"><span className = 'school-label'>Student Information</span></h5>
                    <form className="mb-2">

                    <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Class:
        </label>
        <select
          className={`form-control ${validationStep1 && formDataStep1.class.trim() === '' ? 'is-invalid' : ''}`}
          value={formDataStep1.class}
          onChange={(e) =>
            setFormDataStep1({ ...formDataStep1, class: e.target.value })
          }
        >
         {id == 1 ? eng_class_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>) : odia_class_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
          {/* Add more countries as needed */}
        </select>
        {validationStep1 && formDataStep1.class.trim() === '' && (
          <small className="text-danger">Class is required.</small>
        )}
                   </div>

 {/* name section */}
<div className="mb-2 parent-form">
 <div className="parent-column">
                      <div className="form-group">
                        <label className = 'school-label'><span className="text-danger">*</span>First Name:</label>
                        <input
                          type="text"
                          className={`form-control ${validationStep1 && formDataStep1.firstName.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep1.firstName}
                          onChange={(e) =>
                            setFormDataStep1({ ...formDataStep1, firstName: e.target.value })
                          }
                        />
                        {validationStep1 && formDataStep1.firstName.trim() === '' && (
                          <small className="text-danger">First Name is required.</small>
                        )}
                      </div>
                      </div>
                      <div className="parent-column">
                      <div className="form-group">
                        <label className = 'school-label'>Middle Name:</label>
                        <input
                          type="text"
                          className={`form-control`}

                          value={formDataStep1.middleName}
                          onChange={(e) =>
                            setFormDataStep1({ ...formDataStep1, middleName: e.target.value })
                          }
                        />
                      </div>
                      </div>
                      <div className="parent-column">
                      <div className="form-group">
                        <label className = 'school-label'><span className="text-danger">*</span>Last Name:</label>
                        <input
                          type="text"
                          className={`form-control ${validationStep1 && formDataStep1.lastName.trim() === '' ? 'is-invalid' : ''}`}
                          value={formDataStep1.lastName}
                          onChange={(e) =>
                            setFormDataStep1({ ...formDataStep1, lastName: e.target.value })
                          }
                        />
                        {validationStep1 && formDataStep1.lastName.trim() === '' && (
                          <small className="text-danger">Last Name is required.</small>
                        )}
                      </div>

                      </div>

                      </div>

                      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Gender:
        </label>
        <div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              className="form-check-input"
              id="maleRadio"
              name="gender"
              value="Male"
              checked={formDataStep1.gender === 'Male'}
              onChange={() =>
                setFormDataStep1({ ...formDataStep1, gender: 'Male' })
              }
            />
            <label className="form-check-label" htmlFor="maleRadio">
              <span className = 'school-label'>Male</span>
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              className="form-check-input"
              id="femaleRadio"
              name="gender"
              value="Female"
              checked={formDataStep1.gender === 'Female'}
              onChange={() =>
                setFormDataStep1({ ...formDataStep1, gender: 'Female' })
              }
            />
            <label className="form-check-label" htmlFor="femaleRadio">
            <span className = 'school-label'>Female</span>
            </label>
          </div>
          {/* Add more radio buttons as needed */}
        </div>
        {validationStep1 && !formDataStep1.gender && (
          <small className="text-danger">Gender is required.</small>
        )}
      </div>
 
                   


      <div className="form-group">
                        <label className = 'school-label'>Blood Group:</label>
                        <input
                          type="text"
                          className={`form-control`}
                          value={formDataStep1.blood_group}
                          onChange={(e) =>
                            setFormDataStep1({ ...formDataStep1, blood_group: e.target.value })
                          }
                        />
                       
                      </div>

                      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> Date of Birth:
        </label>

        <InputMask
          mask="99/99/9999"
          className={`form-control ${validationStep1 && (formDataStep1.dateOfBirth.trim() === '' || formDataStep1.dateOfBirth.trim().includes('_')) ? 'is-invalid' : ''}`}
          value={formDataStep1.dateOfBirth}
          onChange={(e) =>
            setFormDataStep1({ ...formDataStep1, dateOfBirth: e.target.value })
          }
          placeholder="DD/MM/YYYY"
        />
        {validationStep1 && formDataStep1.dateOfBirth.trim() === '' && (
          <small className="text-danger">Date of Birth is required.</small>
        )}
      </div>


      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Category:
        </label>
        <select
          className={`form-control ${validationStep1 && formDataStep1.category.trim() === '' ? 'is-invalid' : ''}`}
          value={formDataStep1.category}
          onChange={(e) =>
            setFormDataStep1({ ...formDataStep1, category: e.target.value })
          }
        >
         <option value="" disabled>Select</option>
  <option value={"ST"}>ST</option>
  <option value={"SC"}>SC</option>
  <option value={"OBC"}>OBC</option>
  <option value={"SEBC"}>SEBC</option>
  <option value={"Minority"}>Minority</option>
  <option value={"General"}>General</option>
  
        </select>
        {validationStep1 && formDataStep1.category.trim() === '' && (
          <small className="text-danger">Category is required.</small>
        )}
                   </div>

                   <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Nationality:
        </label>
        <select
          className={`form-control ${validationStep1 && formDataStep1.nationality.trim() === '' ? 'is-invalid' : ''}`}
          value={formDataStep1.nationality}
          onChange={(e) =>
            setFormDataStep1({ ...formDataStep1, nationality: e.target.value })
          }
        >
         <option value="" disabled>Select</option>
  <option value={"Indian"}>Indian</option>
  <option value={"Other"}>Other</option>
  
        </select>
        {validationStep1 && formDataStep1.nationality.trim() === '' && (
          <small className="text-danger">Nationality is required.</small>
        )}
                   </div>

                   <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Religion:
        </label>
        <select
          className={`form-control ${validationStep1 && formDataStep1.religion.trim() === '' ? 'is-invalid' : ''}`}
          value={formDataStep1.religion}
          onChange={(e) =>
            setFormDataStep1({ ...formDataStep1, religion: e.target.value })
          }
        >
  <option value="" disabled>Select</option>
  <option value={"Hinduism"}>Hinduism</option>
  <option value={"Muslim"}>Muslim</option>
  <option value={"Sikhisim"}>Sikhisim</option>
  <option value={"Christian"}>Christian</option>
  <option value={"Other"}>Other</option>
        </select>
        {validationStep1 && formDataStep1.religion.trim() === '' && (
          <small className="text-danger">Religion is required.</small>
        )}
                   </div>

                   <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Mother Tongue:
        </label>
        <select
          className={`form-control ${validationStep1 && formDataStep1.mother_tongue.trim() === '' ? 'is-invalid' : ''}`}
          value={formDataStep1.mother_tongue}
          onChange={(e) =>
            setFormDataStep1({ ...formDataStep1, mother_tongue: e.target.value })
          }
        >
  <option value="" disabled>Select</option>
  <option value={"Odia"}>Odia</option>
  <option value={"Hindi"}>Hindi</option>
  <option value={"Other"}>Other</option>
        </select>
        {validationStep1 && formDataStep1.mother_tongue.trim() === '' && (
          <small className="text-danger">Mother Tongue is required.</small>
        )}
                   </div>

                   <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> Aadhar Number:
        </label>

        <InputMask
          mask="9999 9999 9999"
          className={`form-control ${validationStep1 && (formDataStep1.aadhar_number.trim() === '' || formDataStep1.aadhar_number.trim().includes('_')) ? 'is-invalid' : ''}`}
          value={formDataStep1.aadhar_number}
          onChange={(e) =>
            setFormDataStep1({ ...formDataStep1, aadhar_number: e.target.value })
          }
          placeholder="0000 0000 0000"
        />
        {validationStep1 && formDataStep1.aadhar_number.trim() === '' && (
          <small className="text-danger">Aadhar number is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
         UDISE+ (Permanent Education Number):
        </label>

        <InputMask
          mask="9999 9999 999"
          className={`form-control ${validationStep1 && (formDataStep1.udise_code.length > 0 && formDataStep1.udise_code.includes('_')) ? 'is-invalid' : ''}`}
          value={formDataStep1.udise_code}
          onChange={(e) =>
            setFormDataStep1({ ...formDataStep1, udise_code: e.target.value })
          }
          placeholder="0000 0000 000"
        />
       
      </div>


                    </form>
                    <div style={{ display: "flex", justifyContent: "flex-end"}}>
                    <button  className="btn btn-primary" onClick={handleNextStep}>
                      Next
                    </button>
                   </div>
                  </div>
                )}

                {/* Step 2 */}
                {currentStep === 2 && (
                  <div>
                    <h5 className="card-title"><span className = 'school-label'>Parent Information</span></h5>
                    <form className="mb-2 parent-form">
                      <div className="parent-column">
                      <h6 className = 'school-label'>Father's Info</h6>
                      <div className="form-group">
                        <label className = 'school-label'><span className="text-danger">*</span>Name:</label>
                        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.fatherName.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.fatherName}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, fatherName: e.target.value })
                          }
                        />
                        {validationStep2 && formDataStep2.fatherName.trim() === '' && (
                          <small className="text-danger">Father's Name is required.</small>
                        )}
                      </div>

                      <div className="form-group">
                        <label className = 'school-label'><span className="text-danger">*</span>Qualification:</label>
                        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.f_qualification.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.f_qualification}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, f_qualification: e.target.value })
                          }
                        />
                        {validationStep2 && formDataStep2.f_qualification.trim() === '' && (
                          <small className="text-danger">Father's Qualification is required.</small>
                        )}
                      </div>

                      <div className="form-group">
                        <label className = 'school-label'><span className="text-danger">*</span>Occupation:</label>
                        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.f_Occupation.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.f_Occupation}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, f_Occupation: e.target.value })
                          }
                        />
                        {validationStep2 && formDataStep2.f_Occupation.trim() === '' && (
                          <small className="text-danger">Father's Occupation is required.</small>
                        )}
                      </div>
                      

                      <div className="form-group">
                        <label className = 'school-label'><span className="text-danger">*</span>Organization:</label>
                        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.f_Organization.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.f_Organization}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, f_Organization: e.target.value })
                          }
                        />
                        {validationStep2 && formDataStep2.f_Organization.trim() === '' && (
                          <small className="text-danger">Father's Organization is required.</small>
                        )}
                      </div>

                      <div className="form-group">
                        <label className = 'school-label'><span className="text-danger">*</span>Annual Income:</label>
                        {/* <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.f_Annual_Income.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.f_Annual_Income}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, f_Annual_Income: e.target.value })
                          }
                        /> */}
                        <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text rupee-symbol">₹</span>
        </div>
        <input type="text" 
         className={`form-control ${validationStep2 && formDataStep2.f_Annual_Income.trim() === '' ? 'is-invalid' : ''}`}
         id="f_Annual_Income" 
         value={formDataStep2.f_Annual_Income}
         
         onChange={(e) =>
          {
          let value = e.target.value.replace(/[^\d]/g, '')
          if(value.length > 0)
          {
            let float_val = parseFloat(value)
            if(float_val < 100000000)
            {
              setFormDataStep2({ ...formDataStep2, f_Annual_Income: value })
            }
          }
          else{
             setFormDataStep2({ ...formDataStep2, f_Annual_Income: value })
          }
          
          }
        }
        pattern="[0-9]*"
         />
        <div class="input-group-append">
          <span class="input-group-text decimal-symbol">.00</span>
        </div>
      </div>

                        {validationStep2 && formDataStep2.f_Annual_Income.trim() === '' && (
                          <small className="text-danger">Father's Annual Income is required.</small>
                        )}
                      </div>

                      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Cell Number:
        </label>

        <div class="input-group">
<div class="input-group-append">
          <span class="input-group-text ph_ext-symbol">+91</span>
        </div>

        <InputMask
          mask="9999999999"
          className={`form-control ${validationStep2 && (formDataStep2.f_Cell_Number.trim() === '' || formDataStep2.f_Cell_Number.trim().includes('_')) ? 'is-invalid' : ''}`}
          value={formDataStep2.f_Cell_Number}
          onChange={(e) =>
            setFormDataStep2({ ...formDataStep2, f_Cell_Number: e.target.value, f_Wapp_Number: same_number.is_f_cell_same_as_wapp ?  e.target.value : formDataStep2.f_Wapp_Number })
          }
          placeholder="0000000000"
        />
        
      </div>
      {validationStep2 && formDataStep2.f_Cell_Number.trim() === '' && (
          <small className="text-danger">Father's Cell Number is required.</small>
        )}
      </div>  
      <br/>
      <div className="form-group">
      <input
            type="checkbox"
            id="agreeCheckboxf"
            checked={same_number.is_f_cell_same_as_wapp}
            onChange={ handlefSameNumberChange}
            className="form-check-input"
          />
          <span style={{ marginRight: '5px' , fontSize:'14px', color:'#0b6669'}}> {/* Add space here */}
    Same as Cell Number?
  </span>
<br/>
        <label className = 'school-label'>
        <span className="text-danger">*</span>Whatsapp Number:
        </label>

       
        <div class="input-group">
<div class="input-group-append">
          <span class="input-group-text ph_ext-symbol">+91</span>
        </div>
        <InputMask
          mask="9999999999"
          className={`form-control ${validationStep2 && (formDataStep2.f_Wapp_Number.trim() === '' || formDataStep2.f_Wapp_Number.trim().includes('_')) ? 'is-invalid' : ''}`}
          value={formDataStep2.f_Wapp_Number}
          onChange={(e) =>
            setFormDataStep2({ ...formDataStep2, f_Wapp_Number: e.target.value })
          }
          placeholder="0000000000"
          disabled = {same_number.is_f_cell_same_as_wapp}
        />
         </div>
        {validationStep2 && formDataStep2.f_Wapp_Number.trim() === '' && (
          <small className="text-danger">Father's Whatsapp Number is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'><span className="text-danger">*</span>Email:</label>
        <input
          type="email"
          className={`form-control ${validationStep2 && formDataStep2.f_Email.trim() === '' ? 'is-invalid' : ''}`}
          value={formDataStep2.f_Email}
          onChange={(e) =>
            setFormDataStep2({ ...formDataStep2, f_Email: e.target.value })
          }
          required  
          pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
        />
        {validationStep2 && formDataStep2.f_Email.trim() === '' ? (
          <small className="text-danger">Father's Email is required.</small>
        ) : (validationStep2 && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formDataStep2.f_Email)) && (
          <small className="text-danger">Invalid email format.</small>)}

      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Aadhar Number:
        </label>

        <InputMask
          mask="9999 9999 9999"
          className={`form-control ${validationStep2 && (formDataStep2.f_Aadhar_Number.trim() === '' || formDataStep2.f_Aadhar_Number.trim().includes('_')) ? 'is-invalid' : ''}`}
          value={formDataStep2.f_Aadhar_Number}
          onChange={(e) =>
            setFormDataStep2({ ...formDataStep2, f_Aadhar_Number: e.target.value })
          }
          placeholder="0000 0000 0000"
        />
        {validationStep2 && formDataStep2.f_Aadhar_Number.trim() === '' && (
          <small className="text-danger">Father's Aadhar Number is required.</small>
        )}
      </div>
      <br/>
      
      <label className = 'school-label'>
        <h6 className="school-label">Present Address:</h6> 
        </label>
        <br/>
        <br/> 
          { window.innerWidth < 768 && <br/>}  
      <div className="form-group">
       
        <label className = 'school-label'>
        <span className="text-danger">*</span> House No:
        </label>
        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.c_House_No.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.c_House_No}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2,
                               c_House_No: e.target.value ,
                               p_House_No: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_House_No
                            })
                          }
                        />
        {validationStep2 && formDataStep2.c_House_No.trim() === '' && (
          <small className="text-danger">House Number is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> Street:
        </label>
        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.c_street.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.c_street}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, c_street: e.target.value ,
                              p_street: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_street
                            })
                          }
                        />
        {validationStep2 && formDataStep2.c_street.trim() === '' && (
          <small className="text-danger">Street is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> City/Village:
        </label>
        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.c_City.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.c_City}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, c_City: e.target.value,
                              p_City: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_City
                            })
                          }
                        />
        {validationStep2 && formDataStep2.c_City.trim() === '' && (
          <small className="text-danger">City or Village name is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> Post:
        </label>
        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.c_Post.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.c_Post}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, c_Post: e.target.value ,
                              p_Post: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_Post
                            })
                          }
                        />
        {validationStep2 && formDataStep2.c_Post.trim() === '' && (
          <small className="text-danger">Post name is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> Block:
        </label>
        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.c_Block.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.c_Block}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, c_Block: e.target.value,
                              p_Block: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_Block
                            })
                          }
                        />
        {validationStep2 && formDataStep2.c_Block.trim() === '' && (
          <small className="text-danger">Block name is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> District:
        </label>
        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.c_District.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.c_District}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, c_District: e.target.value,
                              p_District: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_District
                            })
                          }
                        />
        {validationStep2 && formDataStep2.c_District.trim() === '' && (
          <small className="text-danger">District name is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> PIN:
        </label>
        <InputMask
          mask="999999"
          //className={`form-control ${validationStep2 && formDataStep2.c_zipCode.trim() === '' ? 'is-invalid' : ''}`}
          className={`form-control ${validationStep2 && (formDataStep2.c_zipCode.trim() === '' || formDataStep2.c_zipCode.trim().includes('_')) ? 'is-invalid' : ''}`}
          value={formDataStep2.c_zipCode}
          onChange={(e) =>
            setFormDataStep2({ ...formDataStep2, c_zipCode: e.target.value ,
              p_zipCode: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_zipCode
            })
          }
          placeholder="000000"
        />
        {validationStep2 && formDataStep2.c_zipCode.trim() === '' && (
          <small className="text-danger">PIN Code is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> State:
        </label>
        <select
          className={`form-control ${validationStep2 && formDataStep2.c_State.trim() === '' ? 'is-invalid' : ''}`}
          value={formDataStep2.c_State}
          onChange={(e) =>
            setFormDataStep2({ ...formDataStep2, c_State: e.target.value ,
              p_State: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_State
            })
          }
        >
         { state_list.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
          {/* Add more countries as needed */}
        </select>
        {validationStep2 && formDataStep2.c_State.trim() === '' && (
          <small className="text-danger">State Name is required.</small>
        )}
      </div>
                      </div>
                      
                      <div className="parent-column">
                      <h6 className = 'school-label'>Mother's Info</h6>
                      <div className="form-group">
                        <label className = 'school-label'><span className="text-danger">*</span>Name:</label>
                        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.motherName.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.motherName}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, motherName: e.target.value })
                          }
                        />
                        {validationStep2 && formDataStep2.motherName.trim() === '' && (
                          <small className="text-danger">Mother's Name is required.</small>
                        )}
                      </div>

                      <div className="form-group">
                        <label className = 'school-label'><span className="text-danger">*</span>Qualification:</label>
                        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.m_qualification.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.m_qualification}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, m_qualification: e.target.value })
                          }
                        />
                        {validationStep2 && formDataStep2.m_qualification.trim() === '' && (
                          <small className="text-danger">Mother's Qualification is required.</small>
                        )}
                      </div>

                      <div className="form-group">
                        <label className = 'school-label'><span className="text-danger">*</span>Occupation:</label>
                        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.m_Occupation.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.m_Occupation}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, m_Occupation: e.target.value })
                          }
                        />
                        {validationStep2 && formDataStep2.m_Occupation.trim() === '' && (
                          <small className="text-danger">Mother's Occupation is required.</small>
                        )}
                      </div>

                      <div className="form-group">
                        <label className = 'school-label'><span className="text-danger">*</span>Organization:</label>
                        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.m_Organization.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.m_Organization}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, m_Organization: e.target.value })
                          }
                        />
                        {validationStep2 && formDataStep2.m_Organization.trim() === '' && (
                          <small className="text-danger">Mother's Organization is required.</small>
                        )}
                      </div>

                      
                      <div className="form-group">
                        <label className = 'school-label'><span className="text-danger">*</span>Annual Income:</label>
                        {/* <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.m_Annual_Income.trim() === '' ? 'is-invalid' : ''}`}

                          value={formDataStep2.m_Annual_Income}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, m_Annual_Income: e.target.value })
                          }
                        /> */}

<div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text rupee-symbol">₹</span>
        </div>
        <input type="text" 
         className={`form-control ${validationStep2 && formDataStep2.m_Annual_Income.trim() === '' ? 'is-invalid' : ''}`}
         id="m_Annual_Income" 
         value={formDataStep2.m_Annual_Income}
         
        //  onChange={(e) =>
        //   setFormDataStep2({ ...formDataStep2, m_Annual_Income: e.target.value.replace(/\D/g, '') })
        // }

        onChange={(e) =>
          {
          let value = e.target.value.replace(/[^\d]/g, '')
          if(value.length > 0)
          {
            let float_val = parseFloat(value)
            if(float_val < 100000000)
            {
              setFormDataStep2({ ...formDataStep2, m_Annual_Income: value })
            }
          }
          else{
             setFormDataStep2({ ...formDataStep2, m_Annual_Income: value })
          }
          //setFormDataStep3({ ...formDataStep3, prev_Mark: e.target.value.replace(/[^\d.]/g, '') })
          }
        }
        pattern="[0-9]*"
         />
        <div class="input-group-append">
          <span class="input-group-text decimal-symbol">.00</span>
        </div>
      </div>
                        {validationStep2 && formDataStep2.m_Annual_Income.trim() === '' && (
                          <small className="text-danger">Mother's Annual Income is required.</small>
                        )}
                      </div>
                      

                      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Cell Number:
        </label>
        <div class="input-group">
<div class="input-group-append">
          <span class="input-group-text ph_ext-symbol">+91</span>
        </div>
        <InputMask
          mask="9999999999"
          className={`form-control ${validationStep2 && (formDataStep2.m_Cell_Number.trim() === '' || formDataStep2.m_Cell_Number.trim().includes('_')) ? 'is-invalid' : ''}`}
          value={formDataStep2.m_Cell_Number}
          onChange={(e) =>
            //setFormDataStep2({ ...formDataStep2, m_Cell_Number: e.target.value })
            setFormDataStep2({ ...formDataStep2, m_Cell_Number: e.target.value, m_Wapp_Number: same_number.is_m_cell_same_as_wapp ?  e.target.value : formDataStep2.m_Wapp_Number })
          }
          placeholder="0000000000"
        />
        </div>
        {validationStep2 && formDataStep2.m_Cell_Number.trim() === '' && (
          <small className="text-danger">Mother's Cell Number is required.</small>
        )}
      </div>
      <br/>
      
      <div className="form-group">

      <input
            type="checkbox"
            id="agreeCheckboxm"
            checked={same_number.is_m_cell_same_as_wapp}
            onChange={ handlemSameNumberChange}
            className="form-check-input"
          />
          <span style={{ marginRight: '5px' , fontSize:'14px', color:'#0b6669'}}> {/* Add space here */}
    Same as Cell Number?
  </span>
<br/>

        <label className = 'school-label'>
        <span className="text-danger">*</span>Whatsapp Number:
        </label>
        <div class="input-group">
<div class="input-group-append">
          <span class="input-group-text ph_ext-symbol">+91</span>
        </div>
        <InputMask
          mask="9999999999"
          className={`form-control ${validationStep2 && (formDataStep2.m_Wapp_Number.trim() === '' || formDataStep2.m_Wapp_Number.trim().includes('_')) ? 'is-invalid' : ''}`}
          value={formDataStep2.m_Wapp_Number}
          onChange={(e) =>
            setFormDataStep2({ ...formDataStep2, m_Wapp_Number: e.target.value })
          }
          placeholder="0000000000"
          disabled = {same_number.is_m_cell_same_as_wapp}
        />
        </div>
        {validationStep2 && formDataStep2.m_Wapp_Number.trim() === '' && (
          <small className="text-danger">Mother's Whatsapp Number is required.</small>
        )}
      </div>

      
      <div className="form-group">
        <label className = 'school-label'><span className="text-danger">*</span>Email:</label>
        <input
          type="email"
          className={`form-control ${validationStep2 && formDataStep2.m_Email.trim() === '' ? 'is-invalid' : ''}`}
          value={formDataStep2.m_Email}
          onChange={(e) =>
            setFormDataStep2({ ...formDataStep2, m_Email: e.target.value })
          }
          required  
          pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
        />
        {validationStep2 && formDataStep2.m_Email.trim() === '' ? (
          <small className="text-danger">Mother's Email is required.</small>
        ) : (validationStep2 && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formDataStep2.m_Email)) && (
          <small className="text-danger">Invalid email format.</small>)}

         {/* {validationStep2 && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formDataStep2.m_Email) && (
           <small className="text-danger">Invalid email format.</small>
         )} */}

      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Aadhar Number:
        </label>

        <InputMask
          mask="9999 9999 9999"
          className={`form-control ${validationStep2 && (formDataStep2.m_Aadhar_Number.trim() === '' || formDataStep2.m_Aadhar_Number.trim().includes('_')) ? 'is-invalid' : ''}`}
          value={formDataStep2.m_Aadhar_Number}
          onChange={(e) =>
            setFormDataStep2({ ...formDataStep2, m_Aadhar_Number: e.target.value })
          }
          placeholder="0000 0000 0000"
        />
        {validationStep2 && formDataStep2.m_Aadhar_Number.trim() === '' && (
          <small className="text-danger">Mother's Aadhar Number is required.</small>
        )}
      </div>

      <br/>
      <div className="form-group">
        <label className = 'school-label'>
        <h6 className="school-label">Permanent Address:</h6> 
        </label>
        <br/>
        <input
            type="checkbox"
            id="agreeCheckbox"
            checked={formDataStep2.isPresntandCurrentAddressSame}
            onChange={handleAddressCheckboxChange}
            className="form-check-input"
          />
          <span style={{ marginRight: '5px' , fontSize:'14px', color:'#0b6669'}}> {/* Add space here */}
    Same as Present Address?
  </span>
  <br/>
          {/* <br/>
          <br/> */}
        <label className = 'school-label'>
        <span className="text-danger">*</span> House No:
        </label>
        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.p_House_No.trim() === '' ? 'is-invalid' : ''}`}
                            disabled = {formDataStep2.isPresntandCurrentAddressSame}
                          value={formDataStep2.p_House_No}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, p_House_No: e.target.value })
                          }
                        />
        {validationStep2 && formDataStep2.p_House_No.trim() === '' && (
          <small className="text-danger">House Number is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> Street:
        </label>
        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.p_street.trim() === '' ? 'is-invalid' : ''}`}
                          disabled = {formDataStep2.isPresntandCurrentAddressSame}
                          value={formDataStep2.p_street}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, p_street: e.target.value })
                          }
                        />
        {validationStep2 && formDataStep2.p_street.trim() === '' && (
          <small className="text-danger">Street is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> City/Village:
        </label>
        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.p_City.trim() === '' ? 'is-invalid' : ''}`}
                          disabled = {formDataStep2.isPresntandCurrentAddressSame}
                          value={formDataStep2.p_City}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, p_City: e.target.value })
                          }
                        />
        {validationStep2 && formDataStep2.p_City.trim() === '' && (
          <small className="text-danger">City or Village name is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> Post:
        </label>
        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.p_Post.trim() === '' ? 'is-invalid' : ''}`}
                          disabled = {formDataStep2.isPresntandCurrentAddressSame}
                          value={formDataStep2.p_Post}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, p_Post: e.target.value })
                          }
                        />
        {validationStep2 && formDataStep2.p_Post.trim() === '' && (
          <small className="text-danger">Post name is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> Block:
        </label>
        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.p_Block.trim() === '' ? 'is-invalid' : ''}`}
                          disabled = {formDataStep2.isPresntandCurrentAddressSame}
                          value={formDataStep2.p_Block}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, p_Block: e.target.value })
                          }
                        />
        {validationStep2 && formDataStep2.p_Block.trim() === '' && (
          <small className="text-danger">Block name is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> District:
        </label>
        <input
                          type="text"
                          className={`form-control ${validationStep2 && formDataStep2.p_District.trim() === '' ? 'is-invalid' : ''}`}
                          disabled = {formDataStep2.isPresntandCurrentAddressSame}
                          value={formDataStep2.p_District}
                          onChange={(e) =>
                            setFormDataStep2({ ...formDataStep2, p_District: e.target.value })
                          }
                        />
        {validationStep2 && formDataStep2.p_District.trim() === '' && (
          <small className="text-danger">District name is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> PIN:
        </label>
        <InputMask
          mask="999999"
          disabled = {formDataStep2.isPresntandCurrentAddressSame}
          className={`form-control ${validationStep2 && (formDataStep2.p_zipCode.trim() === '' || formDataStep2.p_zipCode.trim().includes('_')) ? 'is-invalid' : ''}`}
          value={formDataStep2.p_zipCode}
          onChange={(e) =>
            setFormDataStep2({ ...formDataStep2, p_zipCode: e.target.value })
          }
          placeholder="000000"
        />
        {validationStep2 && formDataStep2.p_zipCode.trim() === '' && (
          <small className="text-danger">PIN Code is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span> State:
        </label>
        <select
          className={`form-control ${validationStep2 && formDataStep2.p_State.trim() === '' ? 'is-invalid' : ''}`}
          value={formDataStep2.p_State}
          onChange={(e) =>
            setFormDataStep2({ ...formDataStep2, p_State: e.target.value })
          }
          disabled = {formDataStep2.isPresntandCurrentAddressSame}
        >
         { state_list.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
          {/* Add more countries as needed */}
        </select>
        {validationStep2 && formDataStep2.p_State.trim() === '' && (
          <small className="text-danger">State Name is required.</small>
        )}
      </div>

                      </div>
                     
                    </form>
                 
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
  <button style={{ marginRight: '10px' }} className="btn btn-secondary" onClick={handlePrevStep}>
    Previous
  </button>
  <button className="btn btn-primary" onClick={handleNextStep}>
    Next
  </button>
</div>

                   
                  </div>
                )}

                {/* Step 3 */}
                {currentStep === 3 && (
                  <div>
                    <h5 className="card-title"><span className = 'school-label'>Other Information</span></h5>
                    {/* Add your content for Step 3 */}
                    <form className="mb-3">

<div className="form-group">
<label className = 'school-label'>
Special Abilities of Child:
</label>
<input
      type="text"
      className={`form-control`}

      value={formDataStep3.special_Abilities}
      onChange={(e) =>
        setFormDataStep3({ ...formDataStep3, special_Abilities: e.target.value })
      }
    />

</div>

<div className="form-group">
    <label className = 'school-label'>Health Problem (if any):</label>
    <input
      type="text"
      className={`form-control`}
      value={formDataStep3.health_Problem}
      onChange={(e) =>
        setFormDataStep3({ ...formDataStep3, health_Problem: e.target.value })
      }
    />
   
  </div>

  <div className="form-group">
    <label className = 'school-label'>Identified Allergies (if any):</label>
    <input
      type="text"
      className={`form-control`}
      value={formDataStep3.allergy}
      onChange={(e) =>
        setFormDataStep3({ ...formDataStep3, allergy: e.target.value })
      }
    />
   
  </div>


  <div className="form-group">
    <label className = 'school-label'>Name and Address of the School last attended:</label>
    <textarea
      className={`form-control`}
      value={formDataStep3.lastSchool_Info}
      onChange={(e) =>
        setFormDataStep3({ ...formDataStep3, lastSchool_Info: e.target.value })
      }
    />
   
  </div>
  <h6 className = 'school-label'>Marks/Grade Obtained in previous class</h6>
  <div className="mb-3 parent-form">
  
  <div className="parent-column">
                   <div className="form-group">
   <label className = 'school-label'>Medium:</label>
   <select
          className={`form-control`}
          value={formDataStep3.prev_Medium}
          onChange={(e) =>
            setFormDataStep3({ ...formDataStep3, prev_Medium: e.target.value , prev_Class:''})
          }
        >
<option value="" disabled>Select</option>
  <option value={1}>English</option>
  <option value={2}>Odia</option>
        </select>
   
  
 </div>
 </div>

  
        <div className="parent-column">
        
        <div className="form-group">
        <label className = 'school-label'>
        Class:
        </label>
        <select
        disabled = {formDataStep3.prev_Medium !== '' ? false: true}
          className={`form-control`}
          value={formDataStep3.prev_Class}
          onChange={(e) =>
            setFormDataStep3({ ...formDataStep3, prev_Class: e.target.value })
          }
        >
         {formDataStep3.prev_Medium == 1 ? eng_class_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>) : odia_class_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
          {/* Add more countries as needed */}
        </select>
        
                   </div>
                   </div>

                   

 <div className="parent-column">
 <div className="form-group">
        <label className = 'school-label'>
         % of Marks:
        </label>
      

<div class="input-group">
         <input 
        type="text" 
        class="form-control"
         id="prev_Mark" 
         value={formDataStep3.prev_Mark}
        onChange={(e) =>
          {
          let value = e.target.value.replace(/[^\d.]/g, '')
          if(value.length >0)
          {
            let float_val = parseFloat(value)
            if(float_val < 100)
            {
              setFormDataStep3({ ...formDataStep3, prev_Mark: value })
            }
          }
          else{
             setFormDataStep3({ ...formDataStep3, prev_Mark: value })
          }
          //setFormDataStep3({ ...formDataStep3, prev_Mark: e.target.value.replace(/[^\d.]/g, '') })
          }
        }
        /> 


        <div class="input-group-append">
          <span class="input-group-text">%</span>
        </div>
      </div>
       
      </div>
        </div>
  </div>

  <div className="form-group">
    <label className = 'school-label'>Previous Achievements if Any:</label>
    <input
      type="text"
      className={`form-control`}
      value={formDataStep3.previous_Achievemnets}
      onChange={(e) =>
        setFormDataStep3({ ...formDataStep3, previous_Achievemnets: e.target.value })
      }
    />
   
  </div>


  <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Only Child:
        </label>
        <div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              className="form-check-input"
              id="maleRadio"
              name="gender"
              value= {formDataStep3.is_OnlyChild}
              checked={formDataStep3.is_OnlyChild == null ? false : formDataStep3.is_OnlyChild}
              onChange={() =>
                setFormDataStep3({ ...formDataStep3, is_OnlyChild: true })
              }
            />
            <label className="form-check-label" htmlFor="maleRadio">
             
             <span className = 'school-label'>Yes</span>
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              className="form-check-input"
              id="jjRadio"
              name="is_OnlyChild"
              value={formDataStep3.is_OnlyChild}
              checked={formDataStep3.is_OnlyChild == null ? false : !formDataStep3.is_OnlyChild}
              onChange={() =>
                setFormDataStep3({ ...formDataStep3, is_OnlyChild: false })
              }
            />
            <label className="form-check-label" htmlFor="femaleRadio">
            <span className = 'school-label'>No</span>
            </label>
          </div>
          {/* Add more radio buttons as needed */}
        </div>
        {validationStep3 && formDataStep3.is_OnlyChild == null && (
          <small className="text-danger"> required.</small>
        )}
      </div>


      {formDataStep3.is_OnlyChild == false &&
      <div className="mb-3 parent-form">
        <div className="parent-column">
        <h6 className = 'school-label'>Sibling 1 Info</h6>
        <div className="form-group">
   <label className = 'school-label'><span className="text-danger">*</span>Name:</label>
   <input
     type="text"
     className={`form-control`}
     value={formDataStep3.cousin1_Name}
     onChange={(e) =>
       setFormDataStep3({ ...formDataStep3, cousin1_Name: e.target.value })
     }
   />
   {validationStep3 && formDataStep3.cousin1_Name.trim() === '' && (
          <small className="text-danger"> required.</small>
        )}
 </div>

 <div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Class:
        </label>
        <select
          className={`form-control`}
          value={formDataStep3.cousin1_Class}
          onChange={(e) =>
            setFormDataStep3({ ...formDataStep3, cousin1_Class: e.target.value })
          }
        >
         {eng_class_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
          {/* Add more countries as needed */}
        </select>
        {validationStep3 && formDataStep3.cousin1_Class.trim() === '' && (
          <small className="text-danger"> required.</small>
        )}
                   </div>

                   <div className="form-group">
   <label className = 'school-label'><span className="text-danger">*</span>School Name:</label>
   <input
     type="text"
     className={`form-control`}
     value={formDataStep3.cousin1_School_Name}
     onChange={(e) =>
       setFormDataStep3({ ...formDataStep3, cousin1_School_Name: e.target.value })
     }
   />
   {validationStep3 && formDataStep3.cousin1_School_Name.trim() === '' && (
          <small className="text-danger"> required.</small>
        )}
 </div> 
        </div>

        <div className="parent-column">
        <h6 className = 'school-label'>Sibling 2 Info</h6>
        <div className="form-group">
   <label className = 'school-label'>Name:</label>
   <input
     type="text"
     className={`form-control`}
     value={formDataStep3.cousin2_Name}
     onChange={(e) =>
       setFormDataStep3({ ...formDataStep3, cousin2_Name: e.target.value })
     }
   />
  
 </div>

 <div className="form-group">
        <label className = 'school-label'>
        Class:
        </label>
        <select
          className={`form-control`}
          value={formDataStep3.cousin2_Class}
          onChange={(e) =>
            setFormDataStep3({ ...formDataStep3, cousin2_Class: e.target.value })
          }
        >
         {odia_class_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
          {/* Add more countries as needed */}
        </select>
        
                   </div>

                   <div className="form-group">
   <label className = 'school-label'>School Name:</label>
   <input
     type="text"
     className={`form-control`}
     value={formDataStep3.cousin2_School_Name}
     onChange={(e) =>
       setFormDataStep3({ ...formDataStep3, cousin2_School_Name: e.target.value })
     }
   />
  
 </div> 
        </div>
      </div>
}

<h6 className = 'school-label'>Local Guardian Information</h6>

<div className="form-group">
    <label className = 'school-label'>Name:</label>
    <input
      type="text"
      className={`form-control`}
      value={formDataStep3.local_guardian_name}
      onChange={(e) =>
        setFormDataStep3({ ...formDataStep3, local_guardian_name: e.target.value })
      }
    />
   
  </div>

  <div className="form-group">
    <label className = 'school-label'>Address:</label>
    <textarea
      className={`form-control`}
      value={formDataStep3.local_guardian_address}
      onChange={(e) =>
        setFormDataStep3({ ...formDataStep3, local_guardian_address: e.target.value })
      }
    />
   
  </div>
  <div className="mb-3 parent-form">
  <div className="parent-column">
<div className="form-group">
<label className = 'school-label'>
 Contact Number 1:
</label>



<div class="input-group">
<div class="input-group-append">
          <span class="input-group-text ph_ext-symbol">+91</span>
        </div>

<InputMask
mask="9999999999"
className={`form-control ${validationStep3 && (formDataStep3.local_guardian_contact_number1.length > 0 && formDataStep3.local_guardian_contact_number1.includes('_')) ? 'is-invalid' : ''}`}

value={formDataStep3.local_guardian_contact_number1}
onChange={(e) =>
setFormDataStep3({ ...formDataStep3, local_guardian_contact_number1: e.target.value })
}
placeholder="0000000000"
/>


       
      </div>

</div>
</div>
<div className="parent-column">
<div className="form-group">
<label className = 'school-label'>
Contact Number 2:
</label>



<div class="input-group">
<div class="input-group-append">
          <span class="input-group-text ph_ext-symbol">+91</span>
        </div>
        
        <InputMask
mask="9999999999"
className={`form-control ${validationStep3 && (formDataStep3.local_guardian_contact_number2.length > 0 && formDataStep3.local_guardian_contact_number2.includes('_')) ? 'is-invalid' : ''}`}

value={formDataStep3.local_guardian_contact_number2}
onChange={(e) =>
setFormDataStep3({ ...formDataStep3, local_guardian_contact_number2: e.target.value })
}
placeholder="0000000000"
/>


       
      </div>
</div>
</div>
</div>

<div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Accomodation:
        </label>
        <div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              className="form-check-input"
              id="scholarRadio"
              name="scholarRadio"
              value= {formDataStep3.accomodation_type}
              checked={formDataStep3.accomodation_type === 'Day Scholar'}
              onChange={() =>
                setFormDataStep3({ ...formDataStep3, accomodation_type: 'Day Scholar' })
              }
            />
            <label className="form-check-label" htmlFor="scholarRadio">
            <span className = 'school-label'>Day Scholar</span>
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              className="form-check-input"
              id="dayboarding"
              name="dayboarding"
              value= {formDataStep3.accomodation_type}
              checked={formDataStep3.accomodation_type === 'Day Boarding'}
              onChange={() =>
                setFormDataStep3({ ...formDataStep3, accomodation_type: 'Day Boarding' })
              }
            />
            <label className="form-check-label" htmlFor="dayboarding">
             
             <span className = 'school-label'>Day Boarding</span>
            </label>
          </div>

          <div className="form-check form-check-inline">
            <input
              type="radio"
              className="form-check-input"
              id="Residential"
              name="Residential"
              value= {formDataStep3.accomodation_type}
              checked={formDataStep3.accomodation_type === 'Residential'}
              onChange={() =>
                setFormDataStep3({ ...formDataStep3,
                   accomodation_type: 'Residential',
                   is_avail_transport: false,
                   pickup_point: null,
                   distance_from_school: null
                  })
              }
            />
            <label className="form-check-label" htmlFor="Residential">
              
              <span className = 'school-label'>Residential</span>
            </label>
          </div>
          {/* Add more radio buttons as needed */}
        </div>
        {validationStep3 && formDataStep3.accomodation_type.trim() === '' && (
          <small className="text-danger">Accomodation is required.</small>
        )}
      </div>

{formDataStep3.accomodation_type !== 'Residential' && formDataStep3.accomodation_type !== '' &&
<div className="form-group">
        <label className = 'school-label'>
        <span className="text-danger">*</span>Avail School Transport?
        </label>
        <div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              className="form-check-input"
              id="is_avail_transporttrueRadio"
              name="transport"
              value= {formDataStep3.is_avail_transport}
              checked={formDataStep3.is_avail_transport == null ? false : formDataStep3.is_avail_transport}
              onChange={() =>
                setFormDataStep3({ ...formDataStep3, is_avail_transport: true })
              }

            />
            <label className="form-check-label" htmlFor="is_avail_transporttrueRadio">
            <span className = 'school-label'>Yes</span>
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              className="form-check-input"
              id="is_avail_transportfalseRadio"
              name="transport"
              value={formDataStep3.is_avail_transport}
              checked={formDataStep3.is_avail_transport == null ? false : !formDataStep3.is_avail_transport}
              onChange={() =>
                setFormDataStep3({ ...formDataStep3, is_avail_transport: false })
              }
            />
            <label className="form-check-label" htmlFor="is_avail_transportfalseRadio">
            <span className = 'school-label'>No</span>
            </label>
          </div>
          {/* Add more radio buttons as needed */}
        </div>
        {validationStep3 && formDataStep3.is_avail_transport == null && (
          <small className="text-danger"> required.</small>
        )}
      </div>
}
      

 { formDataStep3.is_avail_transport === true && 
 
  <div>
  <div className="form-group">
    <label className = 'school-label'><span className="text-danger">*</span>PickUp Point:</label>
    <input
      type="text"
      className={`form-control ${validationStep3 && formDataStep3.pickup_point.trim() === '' ? 'is-invalid' : ''}`}
      value={formDataStep3.pickup_point}
      onChange={(e) =>
        setFormDataStep3({ ...formDataStep3, pickup_point: e.target.value })
      }
    />
    {validationStep3 && formDataStep3.pickup_point.trim() === '' && (
          <small className="text-danger">Pickup Point is required.</small>
        )}
  </div>

  <div className="form-group">
<label className = 'school-label'>
<span className="text-danger">*</span>Distance of house from School in KM:
</label>

{/* <InputMask
mask="99"
className={`form-control ${validationStep3 && formDataStep3.distance_from_school.trim() === '' ? 'is-invalid' : ''}`}
value={formDataStep3.distance_from_school}
onChange={(e) =>
setFormDataStep3({ ...formDataStep3, distance_from_school: e.target.value })
}
placeholder="00"
/> */}

<div class="input-group">
         <input 
        type="text" 
        class="form-control"
         id="distance_from_school" 
         //placeholder="Enter percentage"
         value={formDataStep3.distance_from_school}
        onChange={(e) =>{
          let value = e.target.value.replace(/[^\d.]/g, '')
          if(value.length >0)
          {
            let float_val = parseFloat(value)
            if(float_val < 100)
            {
              setFormDataStep3({ ...formDataStep3, distance_from_school: value })
            }
          }
          else{
             setFormDataStep3({ ...formDataStep3, distance_from_school: value })
          }
          
        }
          
          }
          
        /> 


        <div class="input-group-append">
          <span class="input-group-text">KM</span>
        </div>
      </div>
{validationStep3 && formDataStep3.distance_from_school.trim() === '' && (
          <small className="text-danger">Distance is required.</small>
        )}
</div>
  
  </div>
  
} 

</form>

<div style={{ display: "flex", justifyContent: "space-between" }}>
  <button style={{ marginRight: '10px' }} className="btn btn-secondary" onClick={handlePrevStep}>
    Previous
  </button>
  <button className="btn btn-primary" onClick={handleNextStep}>
    Next
  </button>
</div>

                  </div>
                )}


                   {currentStep === 4 && (
                  <div>
                    <h5 className="card-title"><span className = 'school-label'>Final Step</span></h5>
                    <h6 className = 'school-label'>You are almost done. Please Click on Submit to Complete the Registration.</h6>

                    <div style={{ display: "flex", justifyContent: "space-between" , marginTop:'100px'}}>
  <button style={{ marginRight: '10px' }} className="btn btn-secondary" onClick={handlePrevStep}>
    Previous
  </button>
  <button className="btn btn-primary position-relative" onClick={handleSave} disabled={isLoading}>
 
    Submit
    {isLoading && (
        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
      )}
  </button>
</div>
                  </div>
                )}
              </div>
           
             

          </div>
        </div>
      </div>
      
      </div>

<Notification
IsSuccess = {IsSuccess}
handleClose = {handleClose}
msgList = {success_modal_info.msgList}
title = {"Success"}
/>

{!error_modal_info.isHideErrorModal && <NotifyError
isHide = {error_modal_info.isHideErrorModal}
 handleCloseErrorModal ={handleCloseErrorModal}
  title = {error_modal_info.title}
   message = {error_modal_info.msg}
    Errors ={error_modal_info.validationError}
/>} 
         </div>
  )
}

export default School